import React, { Component, Fragment } from 'react';
import { Route, Switch } from 'react-router-dom';
import app from '../../../plugins/routes/app';
import { connect } from 'react-redux';

import List from "./TripUnitApproval/TripUnitApprovalList"

class TripUnitApproval extends Component {

    render() {
        let tripapprovals = app.routes.find(x => x.name === 'tripapprovals');
        return (
            <Fragment>
                <Switch>
                    <Route exact path="/app/tripunitapprovals" component={List} />
                    {tripapprovals.routes.map((route, key) => {
                        return <Route
                            path={`${app.path}${tripapprovals.path}${route.path}`}
                            meta={route.meta}
                            component={route.component}
                            key={key}
                        />;
                    })}
                </Switch>
            </Fragment>

        )
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(TripUnitApproval);


// WEBPACK FOOTER //
// ./src/components/App/Views/TripUnitApproval.js